import React from 'react';
import { Mail, User, Lock } from 'lucide-react';
export function Profile() {
  return <div className="space-y-6" data-id="element-479">
      <div data-id="element-480">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-481">Perfil</h1>
        <p className="text-gray-600 mt-1" data-id="element-482">Gerencie suas informações pessoais</p>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-483">
        <div className="flex items-center gap-6 mb-6" data-id="element-484">
          <div className="w-24 h-24 bg-gradient-to-br from-[#8BC4C3] to-[#2C4A6B] rounded-full flex items-center justify-center text-white text-3xl font-bold" data-id="element-485">
            A
          </div>
          <div data-id="element-486">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-487">Admin</h2>
            <p className="text-gray-600" data-id="element-488">admin@idreamy.com</p>
          </div>
        </div>
        <div className="space-y-4" data-id="element-489">
          <div data-id="element-490">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-491">
              Nome
            </label>
            <div className="relative" data-id="element-492">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-493" />
              <input type="text" defaultValue="Admin" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-494" />
            </div>
          </div>
          <div data-id="element-495">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-496">
              E-mail
            </label>
            <div className="relative" data-id="element-497">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-498" />
              <input type="email" defaultValue="admin@idreamy.com" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-499" />
            </div>
          </div>
          <div data-id="element-500">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-501">
              Nova Senha
            </label>
            <div className="relative" data-id="element-502">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-503" />
              <input type="password" placeholder="Digite a nova senha" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-504" />
            </div>
          </div>
          <div className="pt-4" data-id="element-505">
            <button className="px-6 py-2 bg-[#8BC4C3] text-white rounded-lg hover:bg-[#6BABA9] transition-colors font-medium" data-id="element-506">
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>;
}